import React, { useState } from 'react';
import {
    Box,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import UserProfile from '../../components/UserProfile/UserProfile';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import UserPortalSideBar from '../../containers/UserSideBarContainer/UserSideBarContainer'; 
import { PageContainer, ContentContainer } from './UserProfileInfoPage.styles';

export default function UserProfilePage() {
    const theme = useTheme();
    const [, setTabIndex] = useState(0);

    return (
        <>
            <TopNavbar onTabChange={setTabIndex}/>
            <PageContainer>
                <UserPortalSideBar /> 
                <ContentContainer
                    sx={{
                        flex: 1,
                        minHeight: '100vh',
                        bgcolor: alpha(theme.palette.primary.main, 0.02),
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 960,
                            mx: 'auto',
                            width: '100%',
                            px: { xs: 2, sm: 3 },
                            py: { xs: 2.5, sm: 4 },
                        }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                p: { xs: 2.5, sm: 3 },
                                mb: 3,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.paper',
                            }}
                        >
                            <Stack spacing={1} sx={{ maxWidth: 640 }}>
                                <Typography
                                    variant="h5"
                                    component="h1"
                                    sx={{ fontWeight: 700, color: 'text.primary', letterSpacing: '-0.02em' }}
                                >
                                    My profile
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.65 }}>
                                    <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                        Business primary
                                    </Box>
                                    {' '}
                                    can edit billing address, shipping addresses, and company details here.
                                    Company members keep their own name and mobile number only; billing and shipping stay shared for the organisation.
                                </Typography>
                            </Stack>
                        </Paper>
                        <UserProfile readOnly={false}/>
                    </Box>
                </ContentContainer>
            </PageContainer>
        </>
    );
}
